// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"127192bc","491":"1bf813ee","837":"28efd47b"}[chunkId] + ".chunk.js";
};